/* v8 ignore file -- @preserve */
import { computed } from 'vue';
import { searchPlaceholderTextMap } from 'config';

export default function useSearchPlaceholderText(isMobile, isMcom) {
  const newSearchPlaceholderText = computed(() => {
    // mcom
    if (isMcom) {
      return isMobile.value ? searchPlaceholderTextMap.short : searchPlaceholderTextMap.long;
    }

    // bcom
    return searchPlaceholderTextMap.short;
  });

  return {
    newSearchPlaceholderText,
  };
}
